import moment from '@/plugins/vue-moment.js';

export default {
    state: {
        filters: {
            course_id: null,
            causer_id: null,
            date_start: null,
            date_end: null,
        },
    },

    getters: {
        hasFilters(state, getters) {
            return Object.keys(getters.filters).length > 0;
        },

        filters(state) {
            const params = {};

            Object.keys(state.filters).forEach(filterKey => {
                if (state.filters[filterKey]) {
                    params[filterKey] = state.filters[filterKey];
                }
            });

            return params;
        },

        dates(state) {
            return state.date_start && state.date_end ? [state.date_start, state.date_end] : null;
        },
    },

    actions: {
        setDateRange({ commit }, [start, end]) {
            commit('SET_DATE_START', moment.utc(start).hour(0).minute(0).second(0).format('Y-MM-DD HH:mm:ss'));
            commit('SET_DATE_END', moment.utc(end).hour(23).minute(59).second(59).format('Y-MM-DD HH:mm:ss'));
        },
    },

    mutations: {
        SET_COURSE_ID(state, courseId) {
            state.filters.course_id = courseId;
        },

        SET_CAUSER_ID(state, causerId) {
            state.filters.causer_id = causerId;
        },

        SET_DATE_START(state, dateStart) {
            state.filters.date_start = dateStart;
        },

        SET_DATE_END(state, dateEnd) {
            state.filters.date_end = dateEnd;
        },
    },
};
